import styled from 'styled-components';

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 12px;
  width: 100%;
  background-color: #071c3e;
  border: none;
  border-radius: 1.5rem;
  height: 2.5rem;
  cursor: pointer;
`;

export const Title = styled.h4`
  color: #fff;
  margin: 0px;
  font-weight: bold;
`;
